import { TOKENS } from '../data/mockMarket';

export default function TokenIcon({ symbol, size = 24 }: { symbol: string; size?: number }) {
  const info = TOKENS[symbol];
  const color = info?.color ?? '#37496322';
  const label = symbol.slice(0, 1);

  return (
    <div
      className="flex items-center justify-center rounded-full font-semibold text-abyss-950 shrink-0"
      style={{ width: size, height: size, background: color, fontSize: size * 0.42 }}
    >
      {label}
    </div>
  );
}
